let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8JWFt")).then(() => parcelRequire('bFfLz'));